import Dialog from '@material-ui/core/Dialog';
import {DialogProps} from 'packages/common-types/base-types';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import LinearProgress from '@material-ui/core/LinearProgress';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';

type OwnProps = {
  onConfirm: <T>(T: T) => void;
  onCancel?: <T>(T: T) => void;
  title: string;
  description: string;
  loading?: boolean;
};

type Props = DialogProps & OwnProps;

const ConfirmAction = (props: Props) => {
  const {description, onCancel, onConfirm, title, toggle, modalOpen, loading} =
    props;
  return (
    <Dialog
      id="confirm-inscription-dialog"
      open={modalOpen}
      onClose={toggle}
      aria-labelledby=""
    >
      <DialogTitle id="">{title}</DialogTitle>
      {loading && <LinearProgress />}
      <DialogContent>
        <DialogContentText>{description}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          id="cancel-inscription-btn"
          onClick={onCancel ?? toggle}
          color="default"
        >
          Cancel
        </Button>
        <Button onClick={onConfirm} color="primary">
          Confirmar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

ConfirmAction.defaultProps = {
  onCancel: undefined,
  loading: false,
};

ConfirmAction.displayName = 'ConfirmActionDialog';
export default ConfirmAction;
